module.exports = __webpack_public_path__ + "static/media/bell (1)disable.aced4015.svg";